export default "__VITE_ASSET__CLtFVNX5__"